import PetModel from '@/models/Pet';

const GET_PET_TOPIC_HOME = 'GET_PET_TOPIC_HOME';
const GET_MEM_PET_LIST = 'GET_MEM_PET_LIST';
const GET_PET_ORDER_PAGING_LIST = 'GET_PET_ORDER_PAGING_LIST';
const GET_BREED_LIST = 'GET_BREED_LIST';
const GET_MEM_PET_INFO = 'GET_MEM_PET_INFO';
const ADD_MEM_PET = 'ADD_MEM_PET';
const DELETE_MEM_PET = 'DELETE_MEM_PET';
const UPDATE_MEM_PET = 'UPDATE_MEM_PET';

/**
 * 获取H5商城首页数据
 */
async function getPetTopicHome() {
  const payload = await new PetModel().getTopicHome();
  return {
    type: GET_PET_TOPIC_HOME,
    payload
  }
}

/**
 * 宠物列表查询
 */
async function getMemPetList() {
  const payload = await new PetModel().getMemPetList();
  return {
    type: GET_MEM_PET_LIST,
    payload
  }
}

/**
 * 携宠游订单列表
 */
async function getPetOrderPagingList(params) {
  const payload = await new PetModel().petOrderPagingList(params);
  return {
    type: GET_PET_ORDER_PAGING_LIST,
    payload
  }
}

/**
 * 获取宠物品种列表
 */
async function getBreedList(petType) {
  const payload = await new PetModel().getBreedList({ petType });
  return {
    type: GET_BREED_LIST,
    payload
  }
}

/**
 * 宠物详情查询
 */
async function getMemPetInfo(params) {
  const payload = await new PetModel().getMemPetInfo(params);
  return {
    type: GET_MEM_PET_INFO,
    payload
  }
}

/**
 * 添加宠物信息
 */
async function addMemPet(params) {
  const payload = await new PetModel().addMemPet(params);
  return {
    type: ADD_MEM_PET,
    payload
  }
}

/**
 * 删除宠物信息
 */
async function deleteMemPet(id) {
  const payload = await new PetModel().deleteMemPet([ id ]);
  return {
    type: DELETE_MEM_PET,
    payload
  }
}

/**
 * 更新宠物信息
 */
async function updateMemPet(params) {
  const payload = await new PetModel().updateMemPet(params);
  return {
    type: UPDATE_MEM_PET,
    payload
  }
}

const ACTION_TYPES = {
  GET_PET_TOPIC_HOME,
  GET_MEM_PET_LIST,
  GET_PET_ORDER_PAGING_LIST,
  GET_BREED_LIST,
  GET_MEM_PET_INFO,
  ADD_MEM_PET,
  DELETE_MEM_PET,
  UPDATE_MEM_PET,
};

const ACTION = {
  getPetTopicHome,
  getMemPetList,
  getPetOrderPagingList,
  getBreedList,
  getMemPetInfo,
  addMemPet,
  deleteMemPet,
  updateMemPet,
};

const Home = {
  ACTION_TYPES,
  ACTION
}

export default Home;